import Repository from "../../repository";

export default {
    GetUser: (payload) => Repository.post(`/api/RailMaps/GetUser`, payload),
}
